import {
  RegisterTextPromptModal,
  TextPromptModalDescriptor,
  TextPromptResolveValue,
} from "./types";
import { noop } from "../../../../globalConsts";
import { StackControls } from "../useModalStack";

export const useRegisterTextPromptModal =
  ({
    pushDescriptorToStack,
    removeDescriptorFromStack,
  }: StackControls): RegisterTextPromptModal =>
  (config) => {
    const { title, initialValue, required, placeholder } = config || {};

    const descriptor: TextPromptModalDescriptor = {
      type: "textPrompt",
      title,
      initialValue,
      required,
      resolve: noop,
      placeholder,
    };

    const promise = new Promise<TextPromptResolveValue>((resolve) => {
      descriptor.resolve = (result: TextPromptResolveValue): void => {
        resolve(result);
        removeDescriptorFromStack(descriptor);
      };
    });

    pushDescriptorToStack(descriptor);

    return promise;
  };
